// Check if we're on the cart page
if (window.location.pathname === '/cart') {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const hasProduct = cart.items.some(item => item.title === 'SmartHeart 12 Lead ECG');
      const hasSubscription = cart.items.some(item => item.title === 'PlatformSubscription2EKGsMonthl');

      if (hasProduct && !hasSubscription) {
      window.alert('Please select your monthly plan by clicking \'Add To Cart\' in the next screen.');
        
        // Replace 'your-product-handle' with the handle of the product you want to redirect to
        window.location.href = '/products/platformsubscription2ekgsmonthl';
      }
    })
    .catch((error) => console.error('Error:', error));
}
